<template>
    <div style="position:relative">
        <div>
            <multiselect class="form-control" v-model="modelo.idprograma" :options="datos" track-by="id" label="nombre" :searchable="true" :close-on-select="true" :show-labels="false" placeholder="Seleccione...">
              <span slot="noResult">Programa no encontrado</span>
            </multiselect>
        </div>
        <p class="text-primary" style="position:absolute;top:26px"> <small>{{msg}}</small> </p>
    </div>
</template>

<script>
import gql from 'graphql-tag'
import {parseJsonError} from '@/components/Utils.js'
export default {
    props:{ 
        model:Object,
        bysede:{type:Object,required:false}
    },
    data () {
        return {
            msg:'dsfkjsdhkdfjhdfkjhgkjdfh',
            isLoading: false,
            datos: [],
            modelo: {
                idprograma: null,
            }
        }
    },
    watch:{
        'modelo.idprograma': function(){
            this.model.idprograma=this.modelo.idprograma; 
        },
        'bysede': function(){
            // window.console.log( "BySede watch",this.bysede );
            this.asyncFind();
        }
    },
    methods: {
        parseLabel( option ){
            if( option == null ) return "";
            var cat = "";
            if( option.categoria ) cat = option.categoria.nombre;
            return cat+" - "+option.nombre;
        },
        parseLabel2( option ){
            if( option == null ) return "";
            var seg = option.seg_apellido;
            if( seg == null ) seg = "";
            return option.nombres + " "+option.pri_apellido+" "+seg+" - "+option.num_doc;
        },
        limitText (count) {
            return `and ${count} other countries`
        },
        async asyncFind () {
          if( this.bysede.id == null ) return;
          this.msg = 'Cargando...';
            var vue = this;
            var id = this.bysede.id;
            var sql = gql`query{ getProgramas(idsede:${id},todos:true){id,version,gestion,postgrado{nombre,categoria{nombre}}} }`;
            await this.$apollo.query({
                query: sql,
            }).then((data) => {
                vue.datos = [];
                vue.isLoading = false;
                var datas = [];
                data.data.getProgramas.forEach( function(e){
                  var cat = "";
                  if( e.postgrado.categoria ) cat = e.postgrado.categoria.nombre;
                  var nom = "("+e.id+") "+cat+" - "+e.postgrado.nombre+" v"+e.version+" - "+e.gestion;
                  datas.push( {id:e.id,nombre:nom} )
                })

                vue.datos = datas;
                vue.msg = datas.length+' programas.';
                // window.console.log( data.data,vue.datos )

            }).catch((error) => {
                window.console.error(error)
                vue.isLoading = false
                vue.$notify( parseJsonError( error,'getProgramas' ) )
                vue.msg = 'No se pudo conectar al servidor.';
            })
        },
        clearAll () {
            this.modelo.idprograma = null;
        },
    },
    mounted(){
        this.asyncFind();
    }
}
</script>